/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const productWizardNodes = document.querySelectorAll('.product-wizard');

if (productWizardNodes.length > 0) {
    import(/* webpackChunkName: "Configurator" */ './components/ProductWizard').then(({default: Configurator}) => {[...productWizardNodes].forEach((node) => render(<Configurator {...parseDataToProps(node.dataset)} />, node));
    });
}
